import { render, staticRenderFns } from "./PasswordPrompt.vue?vue&type=template&id=c3d953b4"
import script from "./PasswordPrompt.vue?vue&type=script&lang=ts"
export * from "./PasswordPrompt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports